import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { App } from '../../app';

@Component({
    selector: 'app-contact-us',
    standalone: true,
    templateUrl: './contact-us.html',
    styleUrls: [ './contact-us.scss' ],
    imports: [ CommonModule, TooltipModule, ReactiveFormsModule ]
})
export class ContactUs implements OnInit {
    contactForm!: FormGroup;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    constructor(private messageService: MessageService,
                private app: App,
                private fb: FormBuilder) {
    }

    ngOnInit() {
        this.contactForm = this.fb.group({
            yourName: [ '', Validators.required ],
            email: [ '', [ Validators.required, Validators.pattern(this.emailPattern) ] ],
            city: [ '' ],
            mobile: [ '', [ Validators.required, Validators.maxLength(10), Validators.minLength(10) ] ],
            message: [ '' ],
        });

        this.app.isScrolled = true;
        this.app.hideTopStrip = true;

        const items = document.querySelectorAll('.list-group-item');
        items.forEach(item => {
            item.addEventListener('click', () => {
                items.forEach(i => i.classList.remove('active-category'));
                item.classList.add('active-category');
            });
        });

        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.app.isScrolled = window.scrollY < 99999;
        this.app.hideTopStrip = window.scrollY < 99999;
    }

    onSubmit() {
        // console.log(this.contactForm.value);
        if (this.contactForm.valid) {
            this.messageService.add({ severity: 'success', summary: 'Form Submitted', detail: 'Thank you for contacting us!' });
        }
    }
}
